import { Injectable } from '@angular/core';
import { UtilityService } from './utility.service';
import { AngularFireDatabase, AngularFireObject, AngularFireList } from 'angularfire2/database';
import { Constants } from '../config/Constants';
import { Observable } from 'rxjs/Observable';
import * as firebase from 'firebase/app';
import { Exhibitor } from '../models/exhibitor';

@Injectable()
export class ExhibitorsService {

	constructor(private db: AngularFireDatabase, private utilityService: UtilityService) { }

	getSingleExhibitor(eventId: string, exhibitorId: string): Observable<Exhibitor> {
		let data: AngularFireObject<Exhibitor> = this.db.object(Constants.EVENT_URL + '/' + eventId + Constants.EXHIBITORS_URL + "/" + exhibitorId);
		return data.valueChanges();
	}

	getExhibitorsList(eventId: string) {
		if (this.utilityService.isLogged()) {
			return this.db.list(Constants.EVENT_URL + '/' + eventId + Constants.EXHIBITORS_URL);
		}
		return null;
	}

	addExhibitorDetails(exhibitor: Exhibitor, eventId: string) {
		return this.db.list(Constants.EVENT_URL + '/' + eventId + Constants.EXHIBITORS_URL).push(exhibitor).key;
	}

	updateExhibitorDetails(exhibitor: Exhibitor, eventId: string, exhibitorId: string): Promise<any> {
		console.log(exhibitor, eventId, exhibitorId)
		return this.db.object(Constants.EVENT_URL + '/' + eventId + Constants.EXHIBITORS_URL + "/" + exhibitorId).set(exhibitor);
	}

	updateExhibitorPosition(eventID, exhibitorsList) {
		// TODO: This should be 1 query. Right now ther are multiple.
		for (let item of exhibitorsList) {
			let key = item.$key;
			this.db.object(Constants.EVENT_URL + '/' + eventID + Constants.EXHIBITORS_URL + "/" + key).update({ position: item.position });
		}
	}

	getExhibitorType(eventId: string): Observable<Exhibitor> {
		let data: AngularFireObject<Exhibitor> = this.db.object(Constants.EVENT_URL + '/' + eventId + Constants.CATEGORY_EXHIBITORS);
		return data.valueChanges();
	}

	deleteExhibitor(exhibitor: Exhibitor, eventId: string, exhibitorsList) {
		if (exhibitorsList.length <= 0) {
			return this.db.list(Constants.EVENT_URL + '/' + eventId + Constants.EXHIBITORS_URL).remove(exhibitor.$key);
		} else {
			this.db.list(Constants.EVENT_URL + '/' + eventId + Constants.EXHIBITORS_URL).remove(exhibitor.$key);
			let i = 0;
			for (let item of exhibitorsList) {
				let key = item.$key;
				var data = this.db.object(Constants.EVENT_URL + '/' + eventId + Constants.EXHIBITORS_URL + "/" + key).update({ position: item.position });
				i++;
				if (i == exhibitorsList.length) {
					return data;
				}

			}
		}

	} 

	// deleteIconFile(iconName: string) {
	// 	return firebase.storage().ref();
	// }
	// deleteLogoFile(logoName: string) {
	// 	return firebase.storage().ref();
	// }

}



// WEBPACK FOOTER //
// /app/src/app/core/services/exhibitors.service.ts